import {BaseEditItemStore} from "@leap4/frontend";
import {IAlert} from "@leap4/entities-discrepancy-common";

export class EditAlertStore extends BaseEditItemStore<IAlert>{
    entityName: string = "Alert";
}